import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import {
  CreateActivityCategoryPayload,
  SportListingType,
} from 'types/listing/listings'

const getLeagueSportsListing = async () => {
  const response = await axiosGet(`v1/leagueSport`)
  return response.data
}
export const useGetLeagueSportsListing = () => {
  const leagueSports = useQuery<SportListingType[]>(
    ['league-sports-listing'],
    getLeagueSportsListing,
    {
      enabled: false,
    },
  )
  return leagueSports
}

// create new league sport
const createLeagueSport = async ({
  payload,
}: {
  payload: CreateActivityCategoryPayload
}) => {
  const response = await axiosPost(payload, `v1/leagueSport`)
  return response.data
}
export const useCreateLeagueSport = () => {
  const queryClient = useQueryClient()
  return useMutation(createLeagueSport, {
    onSuccess: (newLeagueSport: SportListingType) => {
      queryClient.setQueryData(
        ['league-sports-listing'],
        (oldData: SportListingType[] | undefined) => {
          if (!oldData) return [newLeagueSport]
          return [...oldData, newLeagueSport]
        },
      )
    },
  })
}

// update league sport
const updateLeagueSport = async ({
  sportId,
  payload,
}: {
  sportId: string
  payload: CreateActivityCategoryPayload
}) => {
  const response = await axiosPatch(payload, `v1/leagueSport/${sportId}`)
  return response.data
}
export const useUpdateLeagueSport = () => {
  const queryClient = useQueryClient()
  return useMutation(updateLeagueSport, {
    onSuccess: (updatedLeagueSport: SportListingType) => {
      queryClient.setQueryData(
        ['league-sports-listing'],
        (oldData: SportListingType[] | undefined) => {
          if (!oldData) return [updatedLeagueSport]
          return oldData.map(sport =>
            sport.id === updatedLeagueSport.id ? updatedLeagueSport : sport,
          )
        },
      )
    },
  })
}

//delete league sport
const deleteLeagueSport = async (sportId: string) => {
  const response = await axiosDelete(`v1/leagueSport/${sportId}`)
  return response.data
}
export const useDeleteLeagueSport = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteLeagueSport, {
    onSuccess: (_: any, sportId: string) => {
      queryClient.setQueryData(
        ['league-sports-listing'],
        (oldData: SportListingType[] | undefined) => {
          if (!oldData) return []
          return oldData.filter(sport => sport._id !== sportId)
        },
      )
    },
  })
}
